module.exports = __webpack_public_path__ + "static/images/props-top.e319cb3.png";